import VideoPlayer from '../shared/videoPlayer';
import LockCollateralStatusSignalR from '../shared/lockCollateralStatusSignalR';

const builderForwardVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#builderforward_confirmation_page').length) {
        $(function () {
            var confirmationNumber = $('#hdnConfirmationNumber').val();

            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var logobutton = $('#logo-attach-button');
            var logoinput = $('#logo-attach-input');
            var form = new FormData();
            form.append("confirmationNumber", confirmationNumber);

            var exist = $("#hdnConfirmExists").val();

            if (exist) {
                if ($("#slopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-promotional-flyer',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#slopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:PromoFlyer/")
                                $("#slopenlink").attr("href", response);
                                $("#slopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#socialpmtopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-builder-socialPMT',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#socialpmtopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:SocialPostFlyer/")
                                $("#socialpmtopenlink").attr("href", response);
                                $("#socialpmtopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#educationpostimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-featured-rate-post',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#educationpostimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:FeaturedRateFlyer/")
                                $("#educationpostlink").attr("href", response);
                                $("#educationpostimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }
            }

            // The update button is shown when ANY of the three scenario values (rate, down
            // payment, FICO) differs from what is currently in force on the collateral. The
            // in-force baselines are rendered as data attributes by the view.
            function toggleFeaturedButton() {
                var $scenario = $('#scenario-details-div');

                var rateChanged = $('#new-rate').val() != $('#current_rate').data('rate');
                var downPaymentChanged = $('#new-downpayment').val() != $scenario.data('applied-downpayment');
                var ficoChanged = $('#new-fico').val() != $scenario.data('applied-fico');

                if (rateChanged || downPaymentChanged || ficoChanged)
                    $("#update_featured").removeClass('d-none');
                else
                    $("#update_featured").addClass('d-none');
            }

            $('#new-rate').on('change', function (e) {
                $("#current_rate").removeClass('d-none');
                toggleFeaturedButton();
            });

            $('#new-downpayment, #new-fico').on('change', toggleFeaturedButton);

            function BuildFormData(files) {
                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);

                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                return data;
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            logobutton.on('click', function (e) {
                e.preventDefault();
                logoinput.click();
            });

            input.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-listing-image';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $("#listing-image-form").addClass("d-none");
                        $("#form-listing-image").addClass("d-none");
                        $("#loading-img-listing").removeClass("d-none");
                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            // FIX: Update listing image IMMEDIATELY with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.listingImageUrl && result.listingImageVersion) {
                                var freshImageUrl = result.listingImageUrl;

                                // Ensure _final version (with badge overlay)
                                if (!freshImageUrl.includes('_final')) {
                                    var lastDot = freshImageUrl.lastIndexOf('.');
                                    if (lastDot > 0) {
                                        freshImageUrl = freshImageUrl.substring(0, lastDot) + '_final' + freshImageUrl.substring(lastDot);
                                    }
                                }

                                // Add cache-busting parameter
                                freshImageUrl += '?v=' + result.listingImageVersion;

                                // Update image immediately
                                $('#listing_image').prop('src', freshImageUrl);

                                console.log('[LISTING_IMAGE] Updated immediately to: ' + freshImageUrl);
                            }

                            // Force hard reload to bypass browser cache and ensure fresh flyer thumbnails
                            location.reload(true);
                            return;
                        }

                        console.log(result.error);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            logoinput.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-builder-logo';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#loading-builderlogo').removeClass('d-none');
                        $("#builder-logo-form").addClass("d-none");
                    },
                    success: function (result) {
                        if (result.success) {
                            // Update builder logo immediately with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.builderLogoUrl) {
                                $('#builder_logo').prop('src', result.builderLogoUrl + '?v=' + Date.now());
                                console.log('[BUILDER_LOGO] Updated immediately to: ' + result.builderLogoUrl);
                            }

                            // Force hard reload to bypass browser cache and ensure fresh flyer thumbnails
                            location.reload(true);
                            return;
                        }

                        console.log(result.error);
                        $("#builder-logo-form").removeClass("d-none");
                        $('#loading-builderlogo').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            $('#buttonSendMarketingCollateral').on('click', function (e) {
                e.preventDefault();

                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);
                data.append("builder-email", $("#builder-email").val());

                $.ajax({
                    url: window.location.origin + window.location.pathname + '/send-marketing-collateral',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response.success) {
                            alert("Email sent successfully!")
                            return;
                        }
                    }
                });
            });

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else
                    console.log('current diff: ' + Math.abs(1 - newValue / curValue));
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                console.log('price diff: ' + Math.abs(1 - newValue / curValue));
                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?confirmationNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?confirmationNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function () {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#update_featured').on('click', function (e) {
                e.preventDefault();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = `update-featured?confirmationNumber=${confirmationNumber}`
                    + `&lockrate=${$("#new-rate option:selected").val()}`
                    + `&downpayment=${$("#new-downpayment option:selected").val()}`
                    + `&ficoscore=${$("#new-fico option:selected").val()}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        $("#loading-img-featured").addClass("d-none");
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            // Initialize SignalR for video status updates
            var videoStatusHub = null;

            if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                videoStatusHub = new LockCollateralStatusSignalR(confirmationNumber, builderForwardVideoGenerationTimeout);

                // Initialize SignalR connection
                videoStatusHub.initialize()
                    .then(() => {
                        console.log('SignalR initialized for BuilderForward video status');
                    })
                    .catch((error) => {
                        console.error('SignalR initialization failed, videos will need manual refresh:', error);
                    });
            }

            if ($('#property_video').is('.pending')) {
                // Register property/custom video handler
                // NOTE: Builder products use 'custom' video type for Educational videos
                // (unlike ListNLock which uses 'property')
                videoStatusHub.registerVideoHandler(
                    'custom',
                    // On success
                    function(data) {
                        console.log('Property video SignalR notification received:', data);

                        // Validate data before updating UI
                        if (!data.videoUrl || !data.thumbnailUrl) {
                            console.warn('Property video data incomplete:', data);
                            $('#property_video_loading').addClass('d-none');
                            $('#instructions-div').removeClass('d-none');
                            $('#instructions-div p').text('Video is still processing. Please refresh the page.').addClass('upload-info');
                            return;
                        }

                        // Update UI directly from SignalR data - no AJAX call needed!
                        $('#property_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#property_video').removeClass('pending');
                        $('#property_video_loading').addClass('d-none');

                        // Set download URL if provided
                        if (data.downloadUrl) {
                            $('[download="CustomVideo"]').prop('href', data.downloadUrl);
                            $('[download="CustomVideo"]').parent().removeClass('d-none');
                        }

                        new VideoPlayer();

                        // Set QR code URL if provided
                        if (data.qrCodeUrl) {
                            // FIX: qrCodeUrl is a download URL with fl_attachment flag
                            // For img src, we need the display URL (remove fl_attachment transformation)
                            var qrDisplayUrl = data.qrCodeUrl.replace(/\/fl_attachment:[^\/]+\//, '/');

                            $('#property_video_qr').attr('src', qrDisplayUrl);
                            $('#property_video_qr').removeClass('d-none');
                            $('#property_video_qr_loading').addClass('d-none');

                            // Download link uses the original qrCodeUrl (with fl_attachment)
                            $('[download="VideoQRCode"]').attr('href', data.qrCodeUrl);
                            $('[download="VideoQRCode"]').parent().removeClass('d-none');
                        }

                        $('#instructions-div').addClass('d-none');
                        console.log('Property video UI updated successfully from SignalR data');
                    },
                    // On timeout
                    function(videoType) {
                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    },
                    // On error
                    function(error) {
                        console.error('Property video error:', error);
                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    }
                );
            }

            if ($('#educational_video').is('.pending')) {
                // Register educational/social video handler
                videoStatusHub.registerVideoHandler(
                    'social',
                    // On success
                    function(data) {
                        console.log('Educational video SignalR notification received:', data);

                        // Validate data before updating UI
                        if (!data.videoUrl || !data.thumbnailUrl) {
                            console.warn('Educational video data incomplete:', data);
                            $('#educational_video_loading').addClass('d-none');
                            $('#instructions-edu-div').removeClass('d-none');
                            $('#instructions-edu-div p').text('Video is still processing. Please refresh the page.').addClass('upload-info');
                            return;
                        }

                        // Update UI directly from SignalR data - no AJAX call needed!
                        $('#educational_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#educational_video').removeClass('pending');
                        $('#educational_video_loading').addClass('d-none');

                        // Set download URL if provided
                        if (data.downloadUrl) {
                            $('[download="CustomVideo1"]').prop('href', data.downloadUrl);
                            $('[download="CustomVideo1"]').parent().removeClass('d-none');
                        }

                        new VideoPlayer();

                        $('#instructions-edu-div').addClass('d-none');
                        console.log('Educational video UI updated successfully from SignalR data');
                    },
                    // On timeout
                    function(videoType) {
                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    },
                    // On error
                    function(error) {
                        console.error('Educational video error:', error);
                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    }
                );
            }

            // Database polling fallback - kicks in if SignalR fails or notifications are missed
            var pollingInterval = null;

            function startPollingFallback() {
                if (pollingInterval) {
                    console.log('BFL: Polling fallback already running');
                    return;
                }

                console.log('BFL: Starting polling fallback for pending videos');
                var pollDelay = 10000; // Start at 10s
                var maxDelay = 60000;  // Max 60s between polls
                var maxRetries = 12;   // ~5 minutes total
                var retryCount = 0;
                var consecutiveErrors = 0;

                function poll() {
                    var hasPending = $('#property_video.pending, #educational_video.pending').length > 0;

                    if (!hasPending || retryCount >= maxRetries) {
                        if (!hasPending) console.log('BFL: No pending videos, stopping polling fallback');
                        else console.log('BFL: Max polling retries reached, stopping fallback');
                        pollingInterval = null;
                        return;
                    }

                    retryCount++;
                    console.log('BFL: Polling for video status updates (attempt ' + retryCount + '/' + maxRetries + ')');
                    $.ajax({
                        url: window.location.pathname + '/get-video-status',
                        type: 'GET',
                        data: { confirmationNumber: confirmationNumber },
                        timeout: 15000,
                        success: function(response) {
                            consecutiveErrors = 0;
                            pollDelay = 10000; // Reset delay on success
                            if (response) {
                                console.log('BFL: Polling received video status:', response);
                                updateVideosFromPolling(response);
                            }
                            pollingInterval = setTimeout(poll, pollDelay);
                        },
                        error: function(xhr, status, error) {
                            consecutiveErrors++;
                            console.warn('BFL: Polling failed (attempt ' + retryCount + ', consecutive errors: ' + consecutiveErrors + '):', error);
                            pollDelay = Math.min(pollDelay * 2, maxDelay);
                            pollingInterval = setTimeout(poll, pollDelay);
                        }
                    });
                }

                pollingInterval = setTimeout(poll, pollDelay);
            }

            function updateVideosFromPolling(response) {
                // Update property video if ready and still pending
                if (response.propertyVideo && $('#property_video').is('.pending')) {
                    console.log('BFL: Updating property video from polling');
                    var data = response.propertyVideo;

                    if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Property video has error:', data.videoUrl);
                    } else if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Property thumbnail has error:', data.thumbnailUrl);
                    } else {
                        $('#property_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#property_video [data-role="thumbnail"]').css('background-image', 'url("' + data.thumbnailUrl + '")');
                        $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#property_video').removeClass('pending');
                        $('#property_video_loading').addClass('d-none');

                        if (data.downloadUrl) {
                            $('[download="CustomVideo"]').attr('href', data.downloadUrl);
                            $('[download="CustomVideo"]').parent().removeClass('d-none');
                        }

                        if (data.qrCodeUrl) {
                            var qrDisplayUrl = data.qrCodeUrl.replace(/\/fl_attachment:[^\/]+\//, '/');
                            $('#property_video_qr').attr('src', qrDisplayUrl);
                            $('#property_video_qr').removeClass('d-none');
                            $('#property_video_qr_loading').addClass('d-none');
                            $('[download="VideoQRCode"]').attr('href', data.qrCodeUrl);
                            $('[download="VideoQRCode"]').parent().removeClass('d-none');
                        }

                        $('#instructions-div').addClass('d-none');
                        new VideoPlayer();
                        console.log('BFL: Property video updated from polling');
                    }
                }

                // Update social/educational video if ready and still pending
                if (response.socialVideo && $('#educational_video').is('.pending')) {
                    console.log('BFL: Updating educational video from polling');
                    var data = response.socialVideo;

                    if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Social video has error:', data.videoUrl);
                    } else if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Social thumbnail has error:', data.thumbnailUrl);
                    } else {
                        $('#educational_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#educational_video [data-role="thumbnail"]').css('background-image', 'url("' + data.thumbnailUrl + '")');
                        $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#educational_video').removeClass('pending');
                        $('#educational_video_loading').addClass('d-none');

                        if (data.downloadUrl) {
                            $('[download="CustomVideo1"]').attr('href', data.downloadUrl);
                            $('[download="CustomVideo1"]').parent().removeClass('d-none');
                        }

                        $('#instructions-edu-div').addClass('d-none');
                        new VideoPlayer();
                        console.log('BFL: Educational video updated from polling');
                    }
                }
            }

            // Start polling: 30s grace period after SignalR init, or immediately if SignalR failed
            if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                if (videoStatusHub) {
                    // Give SignalR 30 seconds to deliver notifications before falling back to polling
                    setTimeout(function() {
                        if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                            console.log('BFL: SignalR grace period expired, starting polling fallback');
                            startPollingFallback();
                        }
                    }, 30000);
                } else {
                    // No SignalR connection, start polling immediately
                    startPollingFallback();
                }
            }

            // Clean up SignalR connection and polling when leaving page
            $(window).on('beforeunload', function() {
                if (videoStatusHub) {
                    videoStatusHub.stop();
                }
                if (pollingInterval) {
                    clearTimeout(pollingInterval);
                    pollingInterval = null;
                }
            });

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                // Issue #403: the dialog posts from a visible Address / Address 2 / City /
                // State / Zip form, filled either by picking a Google suggestion (via the
                // 'addresspicked' event GinitMap2 raises) or by typing it in. Address 2 is
                // optional; the other four are required.
                var reorderRequired = '#reorder_line1, #reorder_city, #reorder_state, #reorder_zip';
                var reorderFields = '#reorder_line1, #reorder_line2, #reorder_city, #reorder_state, #reorder_zip';
                var reorderParts = '#street_number, #route, #locality, #administrative_area_level_1, #postal_code';

                function openReorderForm() {
                    $('#reorder_address_fields').removeClass('d-none');
                    $('#reorder_manual_link').addClass('d-none');
                }

                function resetReorderForm() {
                    $(reorderFields).val('').removeClass('blank-error');
                    $(reorderParts).val('');
                    // Clear the visible box too, or reopening shows a valid-looking
                    // address whose fields have been wiped and which will be rejected.
                    $('#autocomplete').val('');
                    $('#reorder_address_fields').addClass('d-none');
                    $('#reorder_manual_link').removeClass('d-none');
                }

                // Keep the search box showing what will actually be posted. Setting the
                // value programmatically fires no 'input' event, so this cannot trip the
                // clear-on-typing handler below.
                function syncReorderSearchBox() {
                    var line1 = $.trim($('#reorder_line1').val());
                    var line2 = $.trim($('#reorder_line2').val());
                    var cityStateZip = [$.trim($('#reorder_city').val()),
                        [$('#reorder_state').val() || '', $.trim($('#reorder_zip').val())].filter(Boolean).join(' ')]
                        .filter(Boolean).join(', ');
                    $('#autocomplete').val([[line1, line2].filter(Boolean).join(' '), cityStateZip].filter(Boolean).join(', '));
                }

                $('#reorder_manual_link').on('click', openReorderForm);

                $('#autocomplete').on('addresspicked', function () {
                    $('#reorder_line1').val([$('#street_number').val(), $('#route').val()].filter(Boolean).join(' '));
                    $('#reorder_line2').val('');
                    $('#reorder_city').val($('#locality').val());
                    $('#reorder_state').val($('#administrative_area_level_1').val());
                    $('#reorder_zip').val($('#postal_code').val());
                    openReorderForm();
                    $('#address_form_error').addClass('d-none');

                    // A suggestion Google could not fully resolve (e.g. no street number)
                    // leaves holes; point at them so the LO finishes it by hand.
                    var filled = $(reorderFields).filter(function () { return !!$(this).val(); }).length;
                    $(reorderRequired).each(function () {
                        $(this).toggleClass('blank-error', filled > 0 && !$(this).val());
                    });
                });

                $(reorderFields).on('keyup change', function () {
                    var $this = $(this);

                    if ($this.is(reorderRequired)) {
                        $this.toggleClass('blank-error', !$this.val());
                    }

                    if (!$(reorderRequired).filter(function () { return !$(this).val(); }).length) {
                        $('#address_form_error').addClass('d-none');
                    }

                    syncReorderSearchBox();
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    resetReorderForm();

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    // Anything posted here overwrites the delivery address stored on
                    // the order, so when the user has not opted into a new address we
                    // must post nothing at all and leave the stored value alone.
                    var postData = {};

                    if ($('#signrider_newaddress').is(':checked')) {
                        var line1 = $.trim($('#reorder_line1').val());
                        var line2 = $.trim($('#reorder_line2').val());
                        var city = $.trim($('#reorder_city').val());
                        var state = $('#reorder_state').val() || '';
                        var zip = $.trim($('#reorder_zip').val());

                        if (!line1 || !city || !state || !zip) {
                            // Address 2 is optional and is never an error when blank.
                            openReorderForm();
                            $(reorderRequired).each(function () {
                                $(this).toggleClass('blank-error', !$(this).val());
                            });
                            $('#address_form_error')
                                .text('Please provide a valid mailing address')
                                .removeClass('d-none');
                            return;
                        }

                        postData = { line1, line2, city, state, zip };
                    }

                    $.post({
                        url: "reorder-yard-sign?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: postData,
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                        .done(function () {
                            $('#success_message, #close_reorder').removeClass('d-none');
                            $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                            $('.dialog-content').children().not('#success_message').addClass('d-none');
                        })
                        .fail(function (xhr) {
                            $('#address_error').removeClass('d-none');
                            $('#signrider_order_error').removeClass('d-none').children().first().text(xhr.status === 400
                                ? 'Please provide a valid mailing address'
                                : 'Unable to place new sign rider order. Please try again.');
                        })
                        .always(function () {
                            $('.dialog-content, .dialog-buttons').removeClass('d-none');
                            $('.dialog-loading').addClass('d-none');
                        });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                // Typing in the search box starts a new address. The form fields and the
                // hidden parts still hold the PREVIOUS one, so without this the reorder
                // would submit an address the LO can no longer see and believes they replaced.
                // Google sets the input value programmatically, which fires no 'input'
                // event, so this cannot clobber a selection it just made.
                $('#autocomplete').on('input', function () {
                    $(reorderFields).val('').removeClass('blank-error');
                    $(reorderParts).val('');
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});